export interface ManualState {
    percent: number;
    loading: boolean;
}

export const SET_PERCENT_UPLOAD = 'SET_PERCENT_UPLOAD'
export const SET_LOADING_MANUAL = 'SET_LOADING_MANUAL'